import React from "react";
import PoliciesHeader from "../Components/PoliciesHeader/PoliciesHeader";
import { useStyle } from "../Components/PoliciesWrapper/Style";
import DisplayAmendedPolicies from "../Components/Policies/DisplayAmendedPolicies";

// Standalone Amended Policies page, mirroring the PEP/AML dashboards.
// DisplayAmendedPolicies fetches its own data (quotations in Un_Confirmed
// status), so no Redux wiring is needed here.
const AmendedPoliciesDashboard = () => {
  const classes = useStyle();

  return (
    <>
      <PoliciesHeader title="Amended Policies" />

      <section className={classes.claimswrapper}>
        <DisplayAmendedPolicies />
      </section>
    </>
  );
};

export default AmendedPoliciesDashboard;
